module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/cover",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_03_cpy",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226389387_07_ack#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226389387_08_int#int"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapt"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226389387_09_ch1#ch1"
    }
  }, [_vm._v("1   Dewey’s Parting Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_10_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2   Trafficking in Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_11_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   Preconditions of Education")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_12_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   Unifying Essence and Existence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   Making Subjects Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6   In Pursuit of Perfection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_15_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7   Education as a Moral Enterprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_16_fur#fur",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_17_bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226389387_18_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc899e64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226389387_06_toc.vue
// module id = 72
// module chunks = 0